import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldTypeKind} from '../enum/field.type.kind'

@EntityTable('component', '030423a9-522d-4a3d-9531-9ac2e417e49c')
export class ComponentEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.TEXT)
    public description: string;

    @Column(FieldTypeKind.STRING)
    public category: string;

    @Column(FieldTypeKind.ANY)
    public keywords: string[];

    @Column(FieldTypeKind.TEXT)
    public template: string;

    @Column(FieldTypeKind.TEXT)
    public toolTip: string;

    @Column(FieldTypeKind.FILE)
    public icon: string;
}
